import { Component, Input, OnInit } from '@angular/core';

import { CHANNEL } from '../../constants/channel.constants';
import { EVENT } from '../../constants/dali.constants';
import { EVENT as EVENT_MULTI } from '../../constants/dali-multiproduct.constants';
import { Changes, TagEvent } from '../../models/dali-tags.model';
import { AbreCuentasService } from '../../services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from '../../services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../services/copies/copy.service';
import { NavigationService } from '../../services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../services/tagging/tagging.service';
import { DaliService } from '@dali/tagger-ng8';
import { IdentificationService } from '../../services/identification/identification.service';
import { BackDocumentScanComponent } from 'src/app/pages/identification/back-document-scan/back-document-scan.component';
import { FrontDocumentInfoComponent } from 'src/app/pages/capture/check-document-info/front-document-info/front-document-info.component';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-header-onboarding',
  templateUrl: './header-onboarding.component.html',
  styleUrls: ['./header-onboarding.component.scss'],
})

/**
 * Clase del componente Header
 *
 * *Header component class*
 *
 * @implements {OnInit}
 */
export class HeaderOnboardingComponent implements OnInit {

  /**
   * Declaración de la variable headerTitle como any, donde se registra el título del header
   *
   * *Set headerTitle variable as any, where it's saved the header title*
   *
   * @access              public
   * @type                {any}
   */
  @Input() headerTitle: any;

  /**
   * Declaración de la variable currentStep como any, donde se registra el paso actual si aplica
   *
   * *Set currentStep variable as any, where it's saved the current step if it applies*
   *
   * @access              public
   * @type                {any}
   */
  @Input() currentStep: any;

  /**
   * Declaración de la variable amountSteps como any, donde se registra la cantidad de pasos de la pantalla si aplica
   *
   * *Set amountSteps variable as any, where it's saved the amount of step if it applies*
   *
   * @access              public
   * @type                {any}
   */
  @Input() amountSteps: any;

  /**
   * Declaración de la variable showSteps como boolean, donde se registra la validación para mostrar los pasos
   *
   * *Set showSteps variable as boolea, where it's saved the steps validation*
   *
   * @access              public
   * @type                {boolean}
   */
  @Input() showSteps = true;

  /**
   * Declaración de la variable showTitle como boolean, donde se registra la validación para mostrar el título de la página
   *
   * *Set showTitle variable as boolea, where it's saved close button validation*
   *
   * @access              public
   * @type                {boolean}
   */
  @Input() showTitle = false;

  /**
   * Variable que valida si se debe mostrar el botón cerrar o no
   *
   * *This variable validates if button close should be shown or not*
   */
  @Input() close = false;

  /**
   * Declaración de la variable isPreviousAvailable como boolean, donde se registra la validación para la pantalla anterior
   *
   * *Set isPreviousAvailable variable as boolea, where it's saved previous screen availability validation*
   *
   * @access              public
   * @type                {boolean}
   */
  isPreviousAvailable: boolean;

  /**
   * Declaración de la variable icons como any, donde se registran los iconos del header
   *
   * *Set icons variable as any, where it's saved headers icons*
   *
   * @access              public
   * @type                {any}
   */
  icons: any = [];

  /**
   * Declaración de la variable headerClass, determina la clase que usara el header
   *
   * *Set class in header*
   *
   * @access              public
   * @type                {string}
   */
  headerClass = '';

  header_close = '';
  close_class = '';

  isPostLogin: boolean;

  // Indicador de cliente nuevo por app
  isNewClient: boolean;

  /**
   * Summary      Constructor of the component.
   *
   * @param {NavigationService}  navigationService  Injectable navigationService service.
   * @param {AbreCuentasService} abreCuentasService Injectable abreCuentasService service.
   */
  constructor(
    public copyService: CopyService,
    public navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private taggingService: TaggingService,
    public channel: ChannelCommunicatorService,
    private bitacoraService: BitacoraService,
    private daliService: DaliService,
  ) { }

  /**
   * Función de Angular ejecutada una vez el componente sea cargado, carga las configuraciones del header
   *
   * *Angular function that is run when the component is loaded, loads header configuration*
   */
  ngOnInit() {
    // if (!this.showCloseButton) {
    //   this.icons = [];
    // } else {
    //   this.icons = [
    //     { icon: 'fechar', a11yLabel: 'Close webview' },
    //   ];
    // }
    this.isNewClient = this.abreCuentasService.getIsNewClient();
    const product = this.abreCuentasService.getproductSelected();
    this.setHeaderClass();
    const productProcess = this.navigationService.getCurrentProductProcess();
    if (productProcess) {
      this.amountSteps = productProcess.totalPhases;
    }
    const step = this.navigationService.getCurrentStep();
    console.log('CURRENSTEP', step);
    const key_step = step !== undefined ? step.key : '';
    if (step) {
      this.isPreviousAvailable = step.previous ? true : false;
      if (step.es) {
        if (step.es === '$type-product-selected') {
          this.headerTitle = this.abreCuentasService.getproductSelected().es;
        } else {
          this.headerTitle = step.es;
        }
      }
    }

    if (key_step === 'selected-product-detail' && product.product_type === 'multi') {
      this.header_close = '';
      this.close_class = 'cross_color';
    } else {
      this.header_close = this.copyService.copies.header_close;
      this.close_class = '';
    }

    const phase = this.navigationService.getCurrentPhase();
    if (phase) {
      this.currentStep = phase.id;
    }
  }

  /**
   * Función para salir de la pantalla actual, si aplica
   *
   * *Function that exits current screen*
   */
  closeApp() {
    this.navigationService.loadExitScreen = true;
    this.sendExitButtonEvent();
    if (!this.taggingService.productsAccepted()) {
      const page = '1';
      const extras = {
        object: 'transactionTransactionStep',
        value: this.abreCuentasService.getPhase(),
      };
      this.taggingService.sendTaggValues('next', page, 'top', '1', extras);
    } else {
      this.pageTagEvent('11');
    }
    console.log(this.navigationService.loadExitScreen);
  }

  /**
   * Función de casos para los alerts para Google Analytics
   *
   * *Cases function for alerts to Google Analytics*
   */
  clickTwoLinkOnb(event) {
    const optionSelected = this.copyService.copies.header_exit_button;
    switch (event.type) {
      case 'action1':
        this.pageTagEvent('10', optionSelected.action1);
        // Envío de registro exit_process
        const bitacoraEvent = `exit_process`;
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        // final de envío de data con bitacoraService
        this.bitacora();
        break;
      case 'action2':
        this.pageTagEvent('10', optionSelected.action2);
        break;
    }
    this.navigationService.loadExitScreen = false;
  }

  bitacora() {
    const stepKey = this.navigationService.getCurrentStep();
    this.isPostLogin = this.abreCuentasService.getPostlogin();
    if (this.channel.getChannelId() === '141' && !this.isPostLogin) {
      switch (stepKey.key) {
        case 'back-document-scan':
          this.bitacoraService.saveDataInBitacora('Salir_' + `${'back-document-scan'}`);
          break;
        case 'front-document-scan':
          this.bitacoraService.saveDataInBitacora('Salir_' + `${'front-document-scan'}`);
          break;
        case 'pep-validation':
          this.bitacoraService.saveDataInBitacora('Salir_' + `${'pep-validation'}`);
          break;
        case 'finger-prints-scan':
          this.bitacoraService.saveDataInBitacora('Salir_' + `${'finger-prints-scan'}`);
          break;

      }
    }

  }

  /**
   * Función para navegar a la pestaña anterior
   *
   * *Function that navigates to prevous screen*
   */
  previous() {
    this.navigationService.previousStep();
  }

  /**
   * Función para navegar a la pestaña anterior
   *
   * *Function that navigates to prevous screen*
   */
  setHeaderClass() {
    this.headerClass =
      this.channel.getChannelId() === CHANNEL.SUPERAPP.CODE || this.channel.getChannelId() === CHANNEL.PORTALALLIES.CODE
        ? 'portal-header'
        : 'transparent-header';
  }

  /**
   * Servicio para enviar datos a Google analytics
   *
   * *Send data to Google Analytics*
   */
  pageTagEvent(tag_number: string, label?: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes = this.taggingService.createTagChanges(tagPageName, tag_number);
      const category = label ? {
        module: 'lightbox',
        type: 'image',
        position: 'center',
      } :
      {
        module: 'header',
        type: 'link',
        position: 'top',
      };
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module[category.module],
          type: EVENT.customCategory.type[category.type],
          position: EVENT.customCategory.position[category.position],
        },
        action: EVENT.customAction.click,
        label: label ? label : EVENT[`${tagPageName}E${tag_number}customLabel`],
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  /* ------------- Taggeo ------------- */

  sendExitButtonEvent(): void {
    const data = [
      {
        path: EVENT_MULTI.pv1E7setData.pv1E7transactionDetailsProductcategory.path,
        value: EVENT_MULTI.pv1E7setData.pv1E7transactionDetailsProductcategory.value,
      },
      {
        path: EVENT_MULTI.pv1E7setData.pv1E7transactionName.path,
        value: EVENT_MULTI.pv1E7setData.pv1E7transactionName.value,
      },
    ];
    const event = {
      category: {
        module: EVENT_MULTI.customCategory.module.header,
        type: EVENT_MULTI.customCategory.type.link,
        position: EVENT_MULTI.customCategory.position.top,
      },
      action: EVENT_MULTI.customAction.click,
      label: EVENT_MULTI.pv1E7customLabel,
    };
    this.daliService.trackEvent(event, data);
    this.sendTagging('header', 'right', '1');
  }

  sendTagging(value: any, position?: string, event?: string, extras?: any) {
    const page = '';
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }

}
